import type { AxiosResponse } from 'axios'
import { bffHTTP } from '@/utils/http/axios'
import { handleAPIException } from '@/utils/exception'
import { userInfoItem, userInfoSubmitItem, multiProductsDeleteResult } from '@/views/corporate-info/types/index'

export async function getCorporates(params: number): Promise<userInfoItem | undefined> {
  try {
    const response: AxiosResponse<userInfoItem, any> = await bffHTTP({
      method: 'GET',
      url: '/corporates?corporate_id=' + params,
    })

    handleAPIException(response)
    return response.data
  } catch (error) {
    console.log('getCorporates', error)
  }
}
export async function putCorporates(list: userInfoSubmitItem): Promise<number | boolean> {
  try {
    const response: AxiosResponse<void, any> = await bffHTTP({
      url: '/corporates',
      method: 'PUT',
      data: list,
    })

    handleAPIException(response)

    return response.status
  } catch (error) {
    console.warn('putCorporates', error)
    return false
  }
}
/**
 * @description 商品一括詳細削除API
 */
export async function deleteMultiProductsApi(): Promise<multiProductsDeleteResult | null> {
  try {
    const response: AxiosResponse<multiProductsDeleteResult, null> = await bffHTTP({
      method: 'DELETE',
      url: `/products/multi`,
    })

    handleAPIException(response)
    return response.data
  } catch (error) {
    console.log('deleteMultiProductsApi', error)
    return null
  }
}
